import React, { useEffect, useState } from "react";
import { Select, DatePicker } from "antd";
import moment from "moment";
import AppInput from "../../../../components/AppInput";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { useParams } from "react-router-dom";

const { Option } = Select;

function ViewBunkerDeliveryCom() {
  const { bunkerdelivery_id } = useParams();
  const [submitStatus, setSubmitStatus] = useState(false);

  const [form, setForm] = useState({
    bunkerRefNo: "",
    bunkerDate: moment(),
    bdnRefNo: "",
    sampleOrigin: "",
    marpolSealNo: "",
    lopIssued: "",
    lopCopyTo: [],
    lopCopyOther: "",
    remarks: "",
    chiefEngSignDigital: "",
    dateSampleDestroyed: null,
    chiefEngSign: "",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const VIEW_BUNKER_DETAILS_LIST = async () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("sulphur_record_id", atob(bunkerdelivery_id));
    try {
      const response = await post(ApiURL?.view_bunker_delivery_bdn_com, FORM_DATA);

      if (response?.status) {
        const data = response?.sulphur_record_two;
        setSubmitStatus(data?.submit_status);
        setForm({
          bunkerRefNo: data?.bunker_ref_no || "",
          bunkerDate: data?.bunker_date ? moment(data.bunker_date) : moment(),
          bdnRefNo: data?.bdn_ref_no || "",
          sampleOrigin: data?.sample_origin || "",
          marpolSealNo: data?.marpol_seal_no || "",
          lopIssued: data?.lop_issued === true ? "Yes" : data?.lop_issued === false ? "No" : "",
          lopCopyTo: data?.lop_copy_to ? [data.lop_copy_to] : [],
          lopCopyOther: data?.lop_copy_other || "",
          remarks: data?.remarks || "",
          chiefEngSignDigital: data?.chief_eng_sign_digital || "",
          dateSampleDestroyed: data?.date_sample_destroyed
            ? moment(data.date_sample_destroyed)
            : null,
          chiefEngSign: data?.chief_eng_sign || "",
        });
      } else {
        console.error("Failed to fetch bunker delivery details:", response);
      }
    } catch (error) {
      console.error("Error in VIEW_BUNKER_DETAILS_LIST:", error);
    }
  };

  useEffect(() => {
    VIEW_BUNKER_DETAILS_LIST();
  }, []);

  return (
    <>
      <div className="white-container">
        <h3>View Bunker delivery note (BDN) & Marpol Sample</h3>
        <br />
        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Bunker Ref. No"
              value={form.bunkerRefNo}
              onChange={(e) => handleChange("bunkerRefNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <label>Bunker Date</label>
            <DatePicker
              disabled={submitStatus}
              value={form.bunkerDate}
              onChange={(date) => handleChange("bunkerDate", date)}
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="BDN Ref. No"
              value={form.bdnRefNo}
              onChange={(e) => handleChange("bdnRefNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <label>Sample Origin (Supplier/Ship)</label>
            <Select
              disabled={submitStatus}
              value={form.sampleOrigin}
              onChange={(value) => handleChange("sampleOrigin", value)}
              placeholder="Select origin"
              style={{ width: "100%" }}
            >
              <Option value="Supplier">Supplier</Option>
              <Option value="Ship">Ship</Option>
              <Option value="Both">Supplier & Ship both</Option>
            </Select>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="MARPOL Sample Seal No."
              value={form.marpolSealNo}
              onChange={(e) => handleChange("marpolSealNo", e.target.value)}
            />
          </div>
          <div className="col-6">
            <label>LOP Issued</label>
            <Select
              disabled={submitStatus}
              value={form.lopIssued}
              onChange={(value) => handleChange("lopIssued", value)}
              placeholder="Select"
              style={{ width: "100%" }}
            >
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <label>LOP Copy To</label>
            <Select
              disabled={submitStatus}
              value={form.lopCopyTo}
              onChange={(value) => handleChange("lopCopyTo", value)}
              placeholder="Select recipients"
              style={{ width: "100%" }}
            >
              <Option value="Supplier">Supplier</Option>
              <Option value="PSC">PSC</Option>
              <Option value="Vessel">Vessel</Option>
              <Option value="Flag">Flag</Option>
              <Option value="Others">Others</Option>
            </Select>
          </div>
          {form.lopCopyTo.includes("Others") && (
            <div className="col-6">
              <AppInput
                disabled={submitStatus}
                label="LOP Copy - Specify Others"
                value={form.lopCopyOther}
                onChange={(e) => handleChange("lopCopyOther", e.target.value)}
              />
            </div>
          )}
        </div>

        <div className="row ">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Remarks (if any)"
              value={form.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Chief Eng. Name & Sign (Digital)"
              value={form.chiefEngSignDigital}
              onChange={(e) => handleChange("chiefEngSignDigital", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <label>Date Sample Destroyed (if - 12 months)</label>
            <DatePicker
              disabled={submitStatus}
              style={{ width: "100%" }}
              type="date"
              value={form?.dateSampleDestroyed}
              onChange={(date) => handleChange("dateSampleDestroyed", date)}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Chief Eng. Name & Sign"
              value={form.chiefEngSign}
              onChange={(e) => handleChange("chiefEngSign", e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewBunkerDeliveryCom;
